import { Persona } from './persona'

export enum ValidationRule {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  EMAIL_ADDRESSES = 'email_addresses',
  DATE_OF_BIRTH = 'date_of_birth',
  GENDER = 'gender',
  ADDRESSES = 'addresses',
  PHONE_NUMBERS = 'phone_numbers',
  GRADUATION_YEAR = 'graduation_year'
}

export class ValidationRules {
  public constructor(public readonly values: string[] = []) {
    if (!values || !Array.isArray(values)) {
      values = []
    }
  }

  public contains(rule: ValidationRule): boolean {
    return this.values && this.values.findIndex(v => v === rule) > -1
  }

  public filterdValues(persona: Persona): string[] {
    return this.values.filter((value) =>
      (value === ValidationRule.FIRST_NAME && !persona.first_name) ||
      (value === ValidationRule.LAST_NAME && !persona.last_name) ||
      (value === ValidationRule.DATE_OF_BIRTH && !persona.date_of_birth) ||
      (value === ValidationRule.ADDRESSES && !persona.primaryAddress.valid) ||
      (value === ValidationRule.PHONE_NUMBERS && !persona.primaryPhone) ||
      (value === ValidationRule.GRADUATION_YEAR && !persona.graduation_year) ||
      (value === ValidationRule.GENDER && !persona.gender) ||
      (value === ValidationRule.EMAIL_ADDRESSES && !persona.email_addresses?.length)
    )
  }
}
